import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";

import {
  tableCellRender,
  stringFilterOperators,
  dateFilterOperators,
  formatDateValue,
  getLatestUpdateAgro,
  twoDecimalsFormat,
} from "../util/tableUtils";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";
import httpClient from "../../lib/httpClient";

export const PerilsList = (props) => {
  const { t } = useTranslation();
  const policyNumber = props.policyNumber;
  const [perils, setPerils] = useState([]);
  const [perilsFetching, setPerilsFetching] = useState(false);
  const [lastUpdateDateMsg, setLastUpdateDateMsg] = useState("");

  useEffect(() => {
    getLatestUpdateAgro("/serviceLogs/agriculture?service=agricultureDb_garanzie").then((lastUpdateMsg) => {
      setLastUpdateDateMsg(lastUpdateMsg);
    });
  }, []);
  useEffect(() => {
    setPerilsFetching(true);
    if (policyNumber) {
      httpClient()
        .get(`/agriculturePolicies/${policyNumber}/perils`)
        .then((res) => res.data)
        .then(async (data) => {
          setPerils(data);
          setPerilsFetching(false);
        });
    }
  }, [policyNumber]);

  const perilColumns = [
    {
      field: "perilCode",
      headerName: t("agriculture.perilCode"),
    },
    {
      field: "perilName",
      headerName: t("agriculture.perilName"),
    },
    {
      field: "inceptionDate",
      headerName: t("agriculture.inceptionDate"),
      type: "date",
      sortable: false,
      filterOperators: dateFilterOperators,
      valueGetter: (params) => params.row.inceptionDate && formatDateValue(params.row.inceptionDate),
    },
    {
      field: "fixedExcess",
      headerName: t("agriculture.fixedExcess"),
    },
    {
      field: "premiumThreshold",
      headerName: t("agriculture.premiumThreshold"),
    },
    {
      field: "premiumNet",
      headerName: t("agriculture.premium"),
      maxWidth: 100,
      valueFormatter: (params) => twoDecimalsFormat(params.value),
      sortable: true,
      align: "right",
    },
  ];

  const columns = perilColumns.map((tableColumn) => ({
    valueFormatter: (params) => tableCellRender(params.value),
    filterOperators: stringFilterOperators,
    flex: 1,
    ...tableColumn,
  }));

  return (
    <Box>
      <Paper>
        <Box p={2} pt={2}>
          <Typography
            variant={"h2"}
            style={{
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("agriculture.perilsTitle")}
          </Typography>
        </Box>
        <div style={{ maxHeight: "50vh", maxWidth: "100%", overflow: "auto" }}>
          <DataGridCystellarTable
            columns={columns}
            rows={perils}
            rowCount={perils.length}
            getRowId={(rowData) => rowData._id}
            pagination={false}
            loading={perilsFetching}
            customToolbarComp={lastUpdateDateMsg ? true : false}
            customToolbarCompMsg={lastUpdateDateMsg}
          />
        </div>
      </Paper>
    </Box>
  );
};
